import { appRouterPaths } from 'services/navigation';
import { AcademicCalendarPage } from 'pages/AcademicCalendar';
import type { AppRouteProps } from '../types';

export const academicCalendarPageRoute: AppRouteProps = {
  path: appRouterPaths.academicCalendar,
  element: <AcademicCalendarPage />,
};
